<template>
  <tm-card class="tm-faq-card">
    <slot />
  </tm-card>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import TmCard from '@/components/shared/cards/TmCard.vue'

export default defineComponent({
  components: { TmCard },
})
</script>

<style lang="scss" scoped>
.tm-faq-card {
  box-shadow: none;
  background-color: initial;
}
</style>
